module.exports = __webpack_public_path__ + "images/emoji/older_woman.4cf51e10243fc83c90a3.png";